// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3Ekut","left":"StickyBox_left__1bVYX","right":"StickyBox_right__1DmCd"};